import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const CopyrightLetterObservation = () => {
  const fileStatus = 36;
  const applicationPath = {
    copyright: "/admin/copyright-letter-observation",
    agreement: "/admin/agreement-letter-observation",
  };

  const objectRoute = {
    11: "/admin/hearing-copyright-details",
    21: "/admin/letter-of-correction-copyright-details",
    27: "/admin/recorded-copyright-details",
    29: "/admin/unauthorized-copyright-details",
  };
  const pageTitle = "চিঠি পর্যবেক্ষণ";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      objectRoute={objectRoute}
      pageTitle={pageTitle}
    />
  );
};

export default CopyrightLetterObservation;
